module.exports = __webpack_public_path__ + "static/media/ZEN.8b5c24d9.svg";